import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function runScheduledCommand(id) {
	return await getAPIResponse("/command-scheduler/scheduled-command/"+id+"/run", {}, "PUT");
}